import React from "react";
import lockSvg from "assets/Lock.svg";
import s from "./PageContainer.module.scss";
import Spin from "components/Spin/Spin";
import { Typography } from "@mui/material";
import c from "lib/style/colorVar.scss";
import { useTranslation } from "react-i18next";
import ErrorOverlay from "./ErrorOverlay";

/**
 * @param {Object} props
 * @param {Boolean} props.loading
 * @param {Boolean} props.noPadding
 * @param {Boolean} props.unauthorized
 * @param {import("react").ReactNode | Boolean | "networkError"} props.errorMessage
 * @param {import("react").ReactNode} props.children
 * @returns
 */

const PageContainer = ({
  loading,
  noPadding,
  unauthorized,
  errorMessage,
  children,
}) => {
  const { t } = useTranslation();

  const renderContent = () => {
    switch (true) {
      case loading: {
        return (
          <div className={s["spin-container"]}>
            <Spin />
          </div>
        );
      }
      case unauthorized: {
        return (
          <div className={s["unauthorized-container"]}>
            <img src={lockSvg} alt="lock" />
            <Typography variant="h1" color={c.brandDark64}>
              {t("component.pageContainer.unauthorized.title")}
            </Typography>
            <Typography variant="content-m" color={c.blackDark666}>
              {t("component.pageContainer.unauthorized.description")}
            </Typography>
          </div>
        );
      }
      case !!errorMessage: {
        return <ErrorOverlay errorMessage={errorMessage} />;
      }
      default: {
        return children;
      }
    }
  };

  return (
    <div
      className={[s["page-container"], noPadding && s["no-padding"]]
        .filter(Boolean)
        .join(" ")}
    >
      {renderContent()}
    </div>
  );
};

export default PageContainer;
